import { http } from '../helpers/axiosHelper';
export default class StepService {
   async createStep(body: Object) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/step', body).then((response) => {
         return response.data;
      });
   }

   async updateStep(body: any) {
      return await http
         .put(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/step/' + body.id, body)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon stap niet wijzigen`);
            }
         })
         .catch((error) => {
            throw Error(`Kon stap niet wijzigen`);
         });
   }

   async patchStep(stepId: Number, body: any) {
      return await http
         .patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/step/' + stepId, body)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon instelling niet wijzigen`);
            }
         })
         .catch((error) => {
            throw Error(`Kon instelling niet wijzigen`);
         });
   }

   async deleteStep(stepId: any) {
      return await http.delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/step/' + stepId);
   }

   async duplicateStep(stepId: any) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/step/' + stepId + '/duplicate')
         .then((response) => {
            return response.data;
         })
         .catch((error) => {
            return error.response.status;
         });
   }

   async getStep(stepId: Number) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/step/' + stepId)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon stap niet ophalen`);
            }
         })
         .catch((error) => {
            throw Error(`Kon stap niet ophalen`);
         });
   }

   async resetStep(id: Number) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/step/' + id + '/reset', {
            params: { include: 'modules.module_type,modules.texts,step_template.slaves,modules.choices' },
         })
         .then((response) => {
            return response.data;
         });
   }
}
